angular.module('smartorg.r6.mgmts.portfolioPermissions', []);
require('./portfolio-permission-directive');
require('../../css/app.css');
module.exports = 'smartorg.r6.mgmts.portfolioPermissions';
//# sourceMappingURL=app.js.map


// WEBPACK FOOTER //
// ./app/widgets/management/portfolio-permissions/app/js/plumbing/app.js